<template>
  <div>
    <h3 class="font-20" :class="isSelfServe ? 'mb-18px' : ''">
      Payment details {{ isAdvisedSeller ? "(optional)" : "" }}
    </h3>
    <div class="payment-alert d-flex align-center col-md-6 px-5 py-2">
      <div
        class="payment-alert__icon-wrapper d-flex justify-center align-center flex-shrink-0 rounded-circle mr-4"
      >
        <v-icon color="white">mdi-lock</v-icon>
      </div>
      <span
        class="font-weight-bold"
        :class="[isSelfServe ? 'font-18 black2-color' : 'black--text']"
        >Your payment is secure.</span
      >
    </div>
    <template v-for="(item, index) in question.Questions">
      <component
        :key="index"
        :is="item.AnswerControlType"
        :question="item"
        :class="[isSelfServe ? 'mb-2' : 'mb-8']"
      ></component>
    </template>
  </div>
</template>

<script>
import InputBase from "@/components/Inputs/InputBase";
import InputMask from "@/components/Inputs/InputMask.vue";
import SelectBase from "@/components/Selects/SelectBase";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { mapGetters } from "vuex";

export default {
  name: "LayoutApplicationPayment",
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  components: {
    InputBase,
    InputMask,
    SelectBase,
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["isAdvisedSeller", "isSelfServe"]),
  },
};
</script>

<style lang="scss" scoped>
.payment-alert {
  background-color: var(--blue-100);
  position: relative;
  margin: 15px 0 32px 0;

  .payment-alert__icon-wrapper {
    background-color: var(--blue-500);
    width: 36px;
    height: 36px;
  }
}

.payment-alert::before {
  content: "";
  width: 8px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background: var(--blue-500);
}
</style>
